import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonButton, IonInput, IonItem, IonToast, IonSelectOption, IonSelect } from '@ionic/angular/standalone';
import { StorageService } from '../services/storage-service/storage.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertController, isPlatform } from '@ionic/angular';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  standalone: true,
  imports: [IonToast,
    IonItem, IonInput, IonButton,
    CommonModule, FormsModule, IonSelectOption, IonSelect
  ],
})
export class HomePage implements OnInit {
  //https://i9fluir.com.br:8082/api

  urlServidor: string = '';

  //Mensagens
  showToast = false;
  toastMessage = '';
  alertCtrl = inject(AlertController);

  //Injeções
  storageService = inject(StorageService);
  router = inject(Router);

  // Método chamado quando o componente é inicializado
  async ngOnInit() {
    try {
      // Verificar se já existe uma URL salva no IndexedDB
      const servidor = await this.storageService.getServidor();

      if (servidor && servidor.url_servidor) {
        // Se a URL do servidor já estiver salva, redireciona para a tela de login
        console.log('URL do servidor encontrada:', servidor.url_servidor);
        this.router.navigate(['/auth/login']); // Redireciona para a tela de login
      } else {
        console.log('Nenhuma URL do servidor encontrada');
      }
    } catch (error) {
      console.error('Erro ao verificar a URL do servidor no IndexedDB:', error);
    }
  }

  /*async onSubmit() {
    if (!this.urlServidor) {
      this.toastMessage = 'URL do servidor é obrigatória';
      this.showToast = true;
      return;
    }

    try {
      await this.storageService.saveServidor(this.urlServidor);
      this.toastMessage = 'URL do servidor salva com sucesso!';
      this.showToast = true;

      if (isPlatform('hybrid')) {
        // Se for app, ignora pop-up e vai direto para login
        this.router.navigate(['/auth/login']);
        return;
      }

      // Se for web, mostra pop-up de escolha
      const alert = await this.alertCtrl.create({
        header: 'Escolha a interface',
        message: 'Para onde deseja ir após salvar a URL?',
        buttons: [
          {
            text: 'Totem',
            handler: () => {
              this.router.navigate(['/first-page']);
            },
          },
          {
            text: 'Login',
            handler: () => {
              this.router.navigate(['/auth/login'], { queryParams: { retaguarda: true } });
            },
          },
        ],
      });

      await alert.present();
    } catch (error) {
      this.toastMessage = 'Erro ao salvar a URL do servidor';
      this.showToast = true;
    }
  }*/
  async onSubmit() {
    if (!this.urlServidor) {
      this.toastMessage = 'URL do servidor é obrigatória';
      this.showToast = true;
      return;
    }

    try {
      await this.storageService.saveServidor(this.urlServidor);

      // Confirma se salvou corretamente
      const servidor = await this.storageService.getServidor();
      if (!servidor || !servidor.url_servidor) {
        this.toastMessage = 'Erro: servidor não foi salvo corretamente!';
        this.showToast = true;
        return;
      }

      this.toastMessage = 'URL do servidor salva com sucesso!';
      this.showToast = true;

      if (isPlatform('hybrid')) {
        this.router.navigate(['/auth/login']);
        return;
      }

      const alert = await this.alertCtrl.create({
        header: 'Escolha a interface',
        message: 'Para onde deseja ir após salvar a URL?',
        buttons: [
          {
            text: 'Totem',
            handler: async () => {
              // garante que ao entrar no totem já tem servidor salvo
              const servidorConfirmado = await this.storageService.getServidor();
              if (servidorConfirmado?.url_servidor) {
                this.router.navigate(['/first-page']);
              } else {
                this.toastMessage = 'Servidor não encontrado!';
                this.showToast = true;
              }
            },
          },
          {
            text: 'Login',
            handler: () => {
              this.router.navigate(['/auth/login'], { queryParams: { retaguarda: true } });
            },
          },
        ],
      });

      await alert.present();
    } catch (error) {
      this.toastMessage = 'Erro ao salvar a URL do servidor';
      this.showToast = true;
    }
  }


}
